export default "__VITE_ASSET__CxjztYvo__"